module.exports = __webpack_public_path__ + "static/media/EURO.25829823.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EURO.jpg
// module id = 1435
// module chunks = 1